module.exports = __webpack_public_path__ + "media/images/weather-icons/fill/thermometer-warmer-5f9dfc8ccdb911dfa0fe592996330abb.svg";